import { toRefs, computed } from 'vue';

//
var script = {
  name: 'FormGroupHeader',
  props: {
    gutterBottom: Boolean
  },
  setup(props) {
    const {
      gutterBottom
    } = toRefs(props);
    const classes = computed(() => {
      return {
        'v-form-group-header--gutter-bottom': gutterBottom.value
      };
    });
    return {
      classes
    };
  }
};
export { script as default };